import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => {
      return import(/* webpackChunkName: "home" */ "@/views/Home/index.vue");
    },
  },
  {
    path: "/about",
    name: "About",
    component: () => {
      return import(/* webpackChunkName: "about" */ "@/views/About/index.vue");
    },
  },
  {
    path: "/join",
    name: "JoinUs",
    component: () => {
      return import(/* webpackChunkName: "join" */ "@/views/JoinUs/index.vue");
    },
  },
  {
    path: "/product",
    name: "Product",
    component: () => {
      return import(/* webpackChunkName: "product" */ "@/views/Product/index.vue");
    },
  },
  {
    path: "/solution",
    name: "solution",
    component: () => {
      return import(/* webpackChunkName: "solution" */ "@/views/Solution/Solution.vue");
    },
  },
];

const router = new VueRouter({
  mode: "history", // 默认:hash
  base: process.env.BASE_URL,
  scrollBehavior: () => {
    return { y: 0 };
  },
  routes,
});

export default router;
